import { FilterConfig } from './filter-config';
import { type OptionsMap } from 'src/types';

export class InputFilterConfig extends FilterConfig {
  get defaultValue(): string {
    return '';
  }

  override get excludeFromReset(): boolean {
    return true;
  }

  override get hideInUrl(): boolean {
    return false;
  }

  isEmpty(value: string): boolean {
    return !value || value.trim() === '';
  }

  toLabel(filterData: string): string | null {
    return filterData || null;
  }

  toQuery(filterData: string): string | null {
    return filterData || null;
  }

  toUrl(filterData: string): string | null {
    return filterData || null;
  }

  // eslint-disable-next-line no-unused-vars
  fromUrl(paramValue: string, _options: OptionsMap): string {
    return paramValue;
  }
}


